export const EXPANSION_REGION_DISABLE_COOKIE = 'expansible_region_disable';
